/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ErroResponse,
  ResumoDashboardResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getDashboardControllerResumoUrl = () => {




  return `/v1/dashboard/resumo`
}

/**
 * @summary Números e exames recentes do ambiente
 */
export const dashboardControllerResumo = async ( options?: Parameters<typeof httpClient>[1]): Promise<ResumoDashboardResponse> => {

  return httpClient<ResumoDashboardResponse>(getDashboardControllerResumoUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDashboardControllerResumoQueryKey = () => {
    return [
    `/v1/dashboard/resumo`
    ] as const;
    }


export const getDashboardControllerResumoQueryOptions = <TData = Awaited<ReturnType<typeof dashboardControllerResumo>>, TError = ErroResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardControllerResumo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDashboardControllerResumoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardControllerResumo>>> = ({ signal }) => dashboardControllerResumo({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dashboardControllerResumo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DashboardControllerResumoQueryResult = NonNullable<Awaited<ReturnType<typeof dashboardControllerResumo>>>
export type DashboardControllerResumoQueryError = ErroResponse


export function useDashboardControllerResumo<TData = Awaited<ReturnType<typeof dashboardControllerResumo>>, TError = ErroResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardControllerResumo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardControllerResumo>>,
          TError,
          Awaited<ReturnType<typeof dashboardControllerResumo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDashboardControllerResumo<TData = Awaited<ReturnType<typeof dashboardControllerResumo>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardControllerResumo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardControllerResumo>>,
          TError,
          Awaited<ReturnType<typeof dashboardControllerResumo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDashboardControllerResumo<TData = Awaited<ReturnType<typeof dashboardControllerResumo>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardControllerResumo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Números e exames recentes do ambiente
 */

export function useDashboardControllerResumo<TData = Awaited<ReturnType<typeof dashboardControllerResumo>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardControllerResumo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDashboardControllerResumoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






